export var chain = [{
  id: 'sanr',
  title: 'SanR',
  desc: 'Decentralized marketplace for crypto price signals',
  href: 'https://sanr.app',
  dimensions: [24, 24],
  accent: '#0DB67A'
}, {
  id: 'insights',
  title: 'Insights',
  desc: 'Market analysis from the San team and community members',
  href: 'https://insights.santiment.net/',
  note: 'SAN chain support soon',
  dimensions: [20, 20],
  accent: 'var(--orange)'
}];